import { Grid, MenuItem, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { ISelect, ParamEnum } from '../../../../../../../shared/types/shared';
import { asyncGetLabelParams } from '../../../../../../../services/param.service';
import AutocompleteField from '../../../../../../components/general/fields/autocompleteField';
import LoadingButtonGeneral from '../../../../../../components/general/buttons/loadingButtonGeneral';
import { AllFilters } from '../hooks/useHistoryallData';
import { HISTORY_TYPE_OPTIONS } from '../constants/ui';

type Props = {
    initialValues: AllFilters;
    submitting?: boolean;
    onSubmit: (values: AllFilters) => void;
    onSearch: () => void;
    onReset?: () => void;
    identificationDisabled?: boolean;
};

interface IHistoryTypeChangeEvent {
    target: { value: string | undefined };
}

type HistoryTypeChangeHandler = (e: IHistoryTypeChangeEvent) => void;

export const AllHistoryFilters = ({
    initialValues,
    submitting,
    onSubmit,
    onReset,
    onSearch,
}: Props) => {
    const [values, setValues] = useState<AllFilters>(initialValues);
    const [pqrChannels, setPqrChannels] = useState<ISelect[]>([]);

    useEffect(() => {
        setValues((prev) => ({
            ...prev,
            identification: initialValues.identification,
        }));
    }, [initialValues.identification]);

    useEffect(() => {
        asyncGetLabelParams(ParamEnum.PQR_RECEPTION_CHANNEL).then(
            setPqrChannels
        );
    }, []);

    const isPqr = values.historyType === 'PQR';

    const handleHistoryTypeChange: HistoryTypeChangeHandler = (e) => {
        setValues((v) => ({
            ...v,
            historyType: (e.target.value ||
                undefined) as AllFilters['historyType'],
            channelId: undefined,
        }));
    };

    return (
        <Grid container spacing={2} mt={1}>
            <Grid item xs={12} md={3}>
                <TextField
                    select
                    fullWidth
                    label="Tipo histórico"
                    value={values.historyType ?? ''}
                    onChange={handleHistoryTypeChange}
                >
                    {HISTORY_TYPE_OPTIONS.map((opt) => (
                        <MenuItem key={opt.value} value={opt.value}>
                            {opt.label}
                        </MenuItem>
                    ))}
                </TextField>
            </Grid>

            <Grid item xs={12} md={3}>
                <AutocompleteField
                    label="Canal PQR"
                    name="channelId"
                    data={pqrChannels}
                    value={values.channelId || ''}
                    disabled={!isPqr}
                    onChangeValue={(val) =>
                        setValues((v) => ({ ...v, channelId: val }))
                    }
                />
            </Grid>

            <Grid item xs={12} md={3} display="flex" alignItems="end" gap={1}>
                <LoadingButtonGeneral
                    title="Buscar"
                    onClick={() => {
                        onSubmit(values);
                        onSearch();
                    }}
                    loading={submitting}
                />
                <LoadingButtonGeneral
                    title="Limpiar"
                    variant="outlined"
                    onClick={() => {
                        setValues({
                            identification: initialValues.identification,
                        });
                        onReset?.();
                    }}
                />
            </Grid>
        </Grid>
    );
};
